import MenuIcon from "@mui/icons-material/Menu";
import { Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { makeStyles } from "@mui/styles";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Route, Switch } from "react-router-dom";
import AccessExceptionsPage from "../pages/AccessExceptionsPage";
import AdminCreateTimeOffPage from "../pages/AdminCreateTimeOffPage";
import AdminCreateTradePage from "../pages/AdminCreateTradePage";
import TimeOffAdministrationPage from "../pages/TimeOffAdministrationPage.jsx";
import MyTradesPage from "../pages/MyTradesPage.jsx";
import EmployeeRequestTimeOffPage from "../pages/EmployeeRequestTimeOffPage";
import EmployeeRequestTradePage from "../pages/EmployeeRequestTradePage";
import EmployeeSeniorityListPage from "../pages/EmployeeSeniorityListPage.jsx";
import MyTimeOffPage from "../pages/MyTimeOffPage.jsx";
import GenerateReportPage from "../pages/GenerateReportPage";
import HomePage from "../pages/HomePage";
import LandingPage from "../pages/LandingPage";
import NotFoundPage from "../pages/NotFoundPage";
import SeniorityListPage from "../pages/SeniorityListPage.jsx";
import TradeAdministrationPage from "../pages/TradeAdministrationPage";
import { selectUserSession } from "../slices/userSession/userSessionSlice";
import { logout } from "../util/authentication";
import {
  APPBAR_HEIGHT_PIXELS,
  DESKTOP_MIN_WIDTH_PIXELS,
  FEATURES,
  FEATURE_ACCESS_TYPE,
  HOME_PATH,
  IAM_CONTRACT,
  TWU_CONTRACT,
} from "../util/constants";
import EnvironmentChip from "./EnvironmentChip";
import HamburgerMenu from "./HamburgerMenu.jsx";
import NotificationsPanel from "./NotificationsPanel";
// import swaLogo from "../assets/Southwest_online_rgb_rev_cropped.png";
// import swaHeartLogo from '../assets/Southwest_Airlines_vector_logo.png';
import { getFeatureAccess } from "../api/userAccess";
import AdminPermanentBid from "../pages/AdminPermanentBid";
import AdminTimeOffWOPPage from "../pages/AdminTimeOffWOPPage.jsx";
import BidAdministrationPage from "../pages/bid/BidAdministrationPage";
import BidChoicesPage from "../pages/bid/BidChoicesPage";
import ManageBidPage from "../pages/bid/ManageBidPage";
import MyBidsPage from "../pages/bid/MyBidsPage";
import CreateTemporaryAssignmentPage from "../pages/CreateTemporaryAssignmentPage";
import DeclarationAdminstrationPage from "../pages/DeclarationAdminstrationPage.jsx";
import EmployeeDataManagement from "../pages/EmployeeDataManagement";
import EmployeePermanentBidIam from "../pages/EmployeePermanentBidIam";
import EmployeePermanentBidTwu from "../pages/EmployeePermanentBidTwu";
import EmployeeTimeOffWOPPage from "../pages/EmployeeTimeOffWOPPage.jsx";
import HomePageOld from "../pages/HomePage.old.jsx";
import ScheduleManagementPage from "../pages/schedule/ScheduleManagementPage";
import TemporaryAssignmentAdministrationPage from "../pages/TemporaryAssignmentAdministrationPage";
import { isNewHomeDashboardActive } from "../util/dashboard/dashboardUtils.js";
import { getUnionContractGivenJobCode } from "../util/workgroupMapper";
import MyDeclarationsPageIam from "./declarations/MyDeclarationsPageIam";
import MyDeclarationsPageTwu from "./declarations/MyDeclarationsPageTwu";
import PageLoading from "./PageLoading";
import StarsAvatar from "./StarsAvatar.jsx";
import PropTypes from "prop-types";
import VoluntaryOTList from "../pages/overtime/VoluntaryOTList.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  appBar: {
    height: `${APPBAR_HEIGHT_PIXELS}px`,
  },
  toolbarMargin: theme.mixins.toolbar,
  userWelcomeAvatar: {
    color: theme.palette.primary.swaBlue,
    backgroundColor: theme.palette.secondary.swaWhite,
  },
  leftSide: {
    height: "inherit",
    justifyContent: "left",
    display: "flex",
    alignItems: "center",
  },
  starsLogo: {
    [theme.breakpoints.down("md")]: {
      fontSize: "15px",
    },
    marginLeft: "-75px",
    fontSize: "35px",
    cursor: "pointer",
  },
  chip: {
    [theme.breakpoints.down("md")]: {
      marginTop: "18px",
      marginLeft: "-65px",
    },
    marginLeft: "5px",
  },
  middle: {
    height: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  swaLogo: {
    [theme.breakpoints.down("md")]: {
      width: "100px",
    },
    width: "250px",
  },
  rightSide: {
    height: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },
}));

const MyToolbar = (props) => (
  <Fragment>
    <AppBar>
      <Toolbar>
        <Grid container className={props.classes.appBar}>
          <Grid item xs={4} className={props.classes.leftSide}>
            <IconButton color="inherit" aria-label="Menu" onClick={props.onMenuClick} size="large">
              <MenuIcon />
            </IconButton>
          </Grid>
          <Grid item xs={4} className={props.classes.middle}>
            {/* <img className={classes.swaLogo} src={isDesktopView ? swaLogo : swaHeartLogo} alt="Southwest Logo" /> */}
            <a href={`#${HOME_PATH}`} style={{ textDecoration: "none" }}>
              <h1 className={props.classes.starsLogo}>STARS</h1>
            </a>

            <div className={props.classes.chip}>
              <EnvironmentChip />
            </div>
          </Grid>
          <Grid item xs={4} className={props.classes.rightSide}>
            <NotificationsPanel isDesktopView={props.isDesktopView} />
            <StarsAvatar />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
    <div className={props.classes.toolbarMargin} />
  </Fragment>
);

MyToolbar.propTypes = {
  isDesktopView: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  onMenuClick: PropTypes.func.isRequired,
};

const AppBarInteraction = () => {
  const classes = useStyles();
  const isDesktopView = useMediaQuery({ minWidth: DESKTOP_MIN_WIDTH_PIXELS });
  const uri = window.location.hash;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const [openCascadeMenu, setOpenCascadeMenu] = useState({});
  const [userFeatures, setUserFeatures] = useState([]);
  const [isUserFeaturesLoading, setIsUserFeaturesLoading] = useState(true);
  const [isLogOutLoading, setIsLogOutLoading] = useState(false);
  const userSession = useSelector(selectUserSession);

  useEffect(() => {
    fetchUserFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedMenuItem(uri.slice(1));
  }, [uri]);

  useEffect(() => {
    const menuItems = Object.values(userFeatures);

    let activeMenuItem = menuItems.find((menu) => menu.childItems.find((child) => child.path === uri.slice(1)));
    if (activeMenuItem) {
      setOpenCascadeMenu({ [activeMenuItem.key]: true });
    } else {
      setOpenCascadeMenu({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDrawerOpen]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleMenuItemClick = () => () => {
    setIsDrawerOpen(!isDrawerOpen);
    setOpenCascadeMenu({});
  };

  const handleParentMenuItemClick = (key) => {
    setOpenCascadeMenu({ [key]: !openCascadeMenu[key] });
  };

  const handleChildMenuItemClick = () => {
    toggleDrawer();
  };

  const logMeOut = async () => {
    toggleDrawer();
    setIsLogOutLoading(true);
    await logout();
  };

  const fetchUserFeatures = () => {
    getFeatureAccess(FEATURE_ACCESS_TYPE.GO)
      .then((res) => res.json())
      .then((payload) => {
        setUserFeatures(payload.features);
        setIsUserFeaturesLoading(false);
      });
  };

  const getRouteForFeature = (feature) => {
    // NOSONAR
    const contract = getUnionContractGivenJobCode(userSession.jobCode);
    switch (feature.key) {
      case FEATURES.HOME:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => {
              return (
                <HomePageOld {...props} userFeatures={Object.values(userFeatures)} isDesktopView={isDesktopView} />
              );
            }}
          />
        );
      case FEATURES.NEW_HOME_DASHBOARD:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <HomePage
                {...props}
                userFeatures={Object.values(userFeatures)}
                featureConfig={userFeatures.homePage}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.ADMIN_TIME_OFF:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <TimeOffAdministrationPage
                {...props}
                featureConfig={userFeatures.timeOffRequest}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.CREATE_TIME_OFF:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <AdminCreateTimeOffPage
                {...props}
                featureConfig={userFeatures.timeOffRequest}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.EMPLOYEE_TIME_OFF:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <MyTimeOffPage {...props} featureConfig={userFeatures.timeOffRequest} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.REQUEST_TIME_OFF:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <EmployeeRequestTimeOffPage
                {...props}
                featureConfig={userFeatures.timeOffRequest}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.EMPLOYEE_TIME_OFF_WOP:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <EmployeeTimeOffWOPPage
                {...props}
                featureConfig={userFeatures.timeOffRequest}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.ADMIN_TIME_OFF_WOP:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <AdminTimeOffWOPPage
                {...props}
                featureConfig={userFeatures.timeOffRequest}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.ADMIN_TRADE:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <TradeAdministrationPage
                {...props}
                featureConfig={userFeatures.tradeForm}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.CREATE_TRADE:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <AdminCreateTradePage {...props} featureConfig={userFeatures.tradeForm} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.EMPLOYEE_TRADE:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <MyTradesPage {...props} featureConfig={userFeatures.tradeForm} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.REQUEST_TRADE:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <EmployeeRequestTradePage
                {...props}
                featureConfig={userFeatures.tradeForm}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.GENERATE_REPORT:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <GenerateReportPage
                {...props}
                featureConfig={userFeatures.generateReport}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.EMPLOYEE_DATA_MANAGEMENT:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <EmployeeDataManagement
                {...props}
                featureConfig={userFeatures.employeeDataManagement}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.MY_PERMANENT_BID:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={
              contract === IAM_CONTRACT ? (
                (props) => (
                  <EmployeePermanentBidIam {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
                )
              ) : contract === TWU_CONTRACT ? (
                (props) => (
                  <EmployeePermanentBidTwu {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
                )
              ) : (
                <></>
              )
            }
          />
        );
      case FEATURES.MANAGE_PERMANENT_BID:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <AdminPermanentBid {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.MY_SENIORITY_LIST:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <EmployeeSeniorityListPage
                {...props}
                featureConfig={userFeatures.seniorityList}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.SENIORITY_LIST:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <SeniorityListPage {...props} featureConfig={userFeatures.seniorityList} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.DECLARATION_ADMINISTRATION:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <DeclarationAdminstrationPage
                {...props}
                featureConfig={userFeatures.declarations}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.CREATE_TEMPORARY_ASSIGNMENT:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <CreateTemporaryAssignmentPage
                {...props}
                featureConfig={userFeatures.tempAssignment}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.ADMIN_TEMPORARY_ASSIGNMENT:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <TemporaryAssignmentAdministrationPage
                {...props}
                featureConfig={userFeatures.tempAssignment}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      case FEATURES.BID_ADMINISTRATION:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <BidAdministrationPage {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.MANAGE_BID:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <ManageBidPage {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.MY_BIDS:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => <MyBidsPage {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />}
          />
        );

      case FEATURES.MY_DECLARATIONS:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={
              contract === IAM_CONTRACT ? (
                (props) => (
                  <MyDeclarationsPageIam
                    {...props}
                    featureConfig={userFeatures.declarations}
                    isDesktopView={isDesktopView}
                  />
                )
              ) : contract === TWU_CONTRACT ? (
                (props) => (
                  <MyDeclarationsPageTwu
                    {...props}
                    featureConfig={userFeatures.declarations}
                    isDesktopView={isDesktopView}
                  />
                )
              ) : (
                <></>
              )
            }
          />
        );

      case FEATURES.BID_CHOICES:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <BidChoicesPage {...props} featureConfig={userFeatures.bid} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.SCHEDULE_MANAGEMENT:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <ScheduleManagementPage {...props} featureConfig={userFeatures.schedule} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.VOLUNTARY_OT_SIGNUP_LIST:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <VoluntaryOTList {...props} featureConfig={userFeatures.overtime} isDesktopView={isDesktopView} />
            )}
          />
        );
      case FEATURES.ACCESS_EXCEPTIONS:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <AccessExceptionsPage
                {...props}
                featureConfig={userFeatures.accessExceptions}
                isDesktopView={isDesktopView}
              />
            )}
          />
        );
      default:
        return "";
    }
  };

  const renderFeatureRoutes = () => {
    return (
      <main className={classes.root}>
        <Switch>
          <Route key="/" exact path="/" component={LandingPage} />
          {Object.values(userFeatures).map((feature) => {
            // If the New Home Dashboard is active, skip rendering the old Home Page
            if (isNewHomeDashboardActive(userFeatures, feature)) {
              return "";
            }

            if (feature.childItems.length > 0) {
              return feature.childItems.map((child) => {
                return getRouteForFeature(child);
              });
            } else {
              return getRouteForFeature(feature);
            }
          })}
          <Route path="/*" component={NotFoundPage} />
        </Switch>
      </main>
    );
  };
  return (
    <div className={classes.root}>
      {isUserFeaturesLoading || isLogOutLoading ? (
        <PageLoading />
      ) : (
        <>
          <MyToolbar
            classes={classes}
            onMenuClick={toggleDrawer}
            userSession={userSession}
            isDesktopView={isDesktopView}
          />
          <HamburgerMenu
            open={isDrawerOpen}
            onClose={toggleDrawer}
            userSession={userSession}
            userFeatures={Object.values(userFeatures)}
            logMeOut={logMeOut}
            setSelectedMenuItem={setSelectedMenuItem}
            selectedMenuItem={selectedMenuItem}
            openCascadeMenu={openCascadeMenu}
            onMenuItemClick={handleMenuItemClick}
            onParentMenuItemClick={handleParentMenuItemClick}
            onChildMenuItemClick={handleChildMenuItemClick}
            isDesktopView={isDesktopView}
          />
          {renderFeatureRoutes()}
        </>
      )}
    </div>
  );
};

export default AppBarInteraction;
